<template lang="pug">
  include ../mixins
  +b.ls-text--height_xs
    bem-text.display_inline(
      tag="p"
      color="white"
      size="2xs"
    ) {{_('Отправляя форму, Вы соглашаетесь с')}}
    |&nbsp;
    bem-link.display_inline(
      block="ls-link"
      color="accent-3"
      size="2xs"
      :href="privacy"
      target='_blank'
    ) {{_('политикой конфиденциальности')}}
    bem-text.display_inline(
      tag="span"
      color="white"
      size="2xs"
    )  &nbsp; {{_('и')}} &nbsp;
    bem-link.display_inline(
      block="ls-link"
      color="accent-3"
      size="2xs"
      :href="rulesTerms"
      target='_blank'
    ) {{_('правилами сайта')}}
</template>

<script>
export default {
  name: 'privacy-rules',
  props: {
    privacy: String,
    rulesTerms: String,
  },
}
</script>
